import HTMLParser from 'html-react-parser';
import {
  TitleRteBlockElementContentModel,
  TitleRteBlockPropertiesModel,
  TitleRteItemPropertiesModel,
  ApiBlockItemModel,
} from '@/services/platform/api/model';
import { ModuleProperties } from '@/lib/core/types';
import { useClientTranslation } from '@/lib/core/i18n';
import { formatDateMinimal } from '@/lib/core/utils/dateTime';

export function TitleRteBlock({ content, context, index }: ModuleProperties) {
  const t = useClientTranslation();
  const blockProps = (content as TitleRteBlockElementContentModel | undefined)?.properties as
    | TitleRteBlockPropertiesModel
    | undefined;
  const sections = (blockProps?.textSection?.items ?? []) as ApiBlockItemModel[];
  const updateDate = index === 0 ? context?.page?.updateDate : undefined;

  return (
    <div className="flex flex-col gap-6 px-4 pt-4 pb-16">
      {updateDate && (
        <p className="font-pp-neue-montreal text-[12px] tracking-[0.5px] text-[#1a1a1a]">
          {t('App.Labels.LastUpdate')} {formatDateMinimal(updateDate)}
        </p>
      )}

      {sections.map((item, i) => {
        const sectionProps = item.content?.properties as TitleRteItemPropertiesModel | undefined;
        const sectionTitle = sectionProps?.title;
        const sectionMarkup = sectionProps?.text?.markup;

        if (!sectionTitle && !sectionMarkup) return null;

        return (
          <div key={i} className="flex flex-col gap-2">
            {sectionTitle && (
              <p className="font-pp-neue-montreal text-[20px] leading-normal font-semibold text-[#1a1a1a]">
                {sectionTitle}
              </p>
            )}
            {sectionMarkup && (
              <div className="font-pp-neue-montreal text-[16px] leading-normal tracking-[0.25px] text-[#1a1a1a] [&_li]:ml-6 [&_li]:leading-normal [&_p]:leading-normal [&_ul]:list-disc">
                {HTMLParser(sectionMarkup)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
